"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshToken = exports.FailedTokenRefresh = void 0;
const addTokenToHeader_1 = require("../../middleware/addTokenToHeader");
class FailedTokenRefresh extends Error {
    constructor() {
        super("Failed to refresh auth token, credentials may be invalid or expired");
        this.name = this.constructor.name;
    }
}
exports.FailedTokenRefresh = FailedTokenRefresh;
const refreshToken = async (authService) => {
    await authService.getToken();
    const newIdToken = await authService.getIdToken();
    if (newIdToken) {
        window.sessionStorage.setItem(addTokenToHeader_1.SessionToken.IdToken, newIdToken);
    }
    else {
        throw new FailedTokenRefresh();
    }
    return newIdToken;
};
exports.refreshToken = refreshToken;
